module.exports = __webpack_public_path__ + "static/image-hero-e1ddc70dafb495a2eac636a790fc4eeb.jpg";